import createReducer from "rdx/utils/createReducer";
import types from "rdx/types";

export default {
  profile: createReducer(null, {
    [types.SET_PROFILE](state, action) {
      return action.payload;
    },
    [types.SET_RESUME](state, action) {
      return {
        ...state,
        resume: action.payload,
      };
    },
  }),
  // INSERTION_PT (for script, do not remove)
};
